import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ChangePassword, Login, LoginResult } from '../models';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  constructor(
    private apiService: ApiService,
    private jwtHelper: JwtHelperService,
    private router: Router
  ) {}

  login(login: Login): Observable<LoginResult> {
    return this.apiService.post('/users/authenticate', login).pipe(map(data => data.data));
  }

  isLoggedIn() {
    // check user is logged
    const token = this.jwtHelper.tokenGetter();
    return !this.jwtHelper.isTokenExpired(token);
  }

  hasPermission(roles: string[]) {
    const token = this.jwtHelper.tokenGetter();
    const userRole: string = this.jwtHelper.decodeToken(token).roles || '';
    if (!roles.length || roles.length === 0) {
      return true;
    }
    return roles.includes(userRole);
  }

  logout(): void {
    // clear token  from local storage to log user out
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_data');
    this.router.navigate(['./login']);
  }

  chnagePassword(changePassword: ChangePassword): Observable<boolean> {
    return this.apiService.post('/users/change-password', changePassword).pipe(map(data => data));
  }
}
